// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1vdR9","title":"FrontImage_title__31XMH"};